import { render } from "./FilterItemEditData.vue?vue&type=template&id=5bc7238e"
import script from "./FilterItemEditData.vue?vue&type=script&lang=js"
export * from "./FilterItemEditData.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__